import { render, staticRenderFns } from "./dishes.vue?vue&type=template&id=76bf3b18&scoped=true&"
import script from "./dishes.vue?vue&type=script&lang=js&"
export * from "./dishes.vue?vue&type=script&lang=js&"
import style0 from "./dishes.vue?vue&type=style&index=0&id=76bf3b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bf3b18",
  null
  
)

export default component.exports